import { ErrorHandler, Injectable } from "@angular/core";
import * as Sentry from "@sentry/angular";
import { AppEnvironments } from "../_constants";

@Injectable({
    providedIn: 'root'
})
export class SentryLoggingService implements ErrorHandler {
    handleError(error: any): void {
        Sentry.captureException(error.originalError || error);
        throw error; // Rethrow so Angular still shows red error
    }
    public appEnvironment: string;
    constructor() {

    }

    logMessage(message: any, action: string = "") {
        if (message) {
            Sentry.captureMessage(
                `Log-Action: ${action}, Message: ${JSON.stringify(message)}, Environment: ${JSON.stringify(this.getEnvironment())}`
            );
        }
    }

    getEnvironment() {
        let url = window.location.host;
        let env = "";
        if (process.env.NODE_ENV === AppEnvironments.Production) {
            if (url.indexOf("salesctd") !== -1) env = AppEnvironments.CTD;
            else env = AppEnvironments.Production;
        } else env = AppEnvironments.Development;
        return env;
    }
}